var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkIndicatorNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11557_4726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 26.8516C15.3546 26.8516 16.25 25.9561 16.25 24.8516C16.25 23.747 15.3546 22.8516 14.25 22.8516C13.1454 22.8516 12.25 23.747 12.25 24.8516C12.25 25.9561 13.1454 26.8516 14.25 26.8516Z",
    fill: "#005C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0469 11.2161C23.4387 8.25692 18.9165 6.63965 14.25 6.63965C9.58354 6.63965 5.0613 8.25692 1.45312 11.2161",
    stroke: "#005C00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1094 15.6233C20.5878 13.6271 17.466 12.541 14.25 12.541C11.034 12.541 7.91218 13.6271 5.39062 15.6233",
    stroke: "#005C00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 20.0519C17.7417 19.0116 16.0186 18.4512 14.25 18.4512C12.4814 18.4512 10.7583 19.0116 9.32812 20.0519",
    stroke: "#005C00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11557_4726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 31.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkIndicatorNormal);
export default __webpack_public_path__ + "static/media/network_indicator_normal.6f8a37f3b94ceaa431db30fdb70443dc.svg";
export { ForwardRef as ReactComponent };